
import { greekSearchFilter } from "@/helpers/data";
import { getOptimalTextColor } from "@/helpers/data";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class LabelCombo extends Vue {
    selectedLabel: LabelDto = { id: 0, name: '', color: '#FFFFFF' };
    @Prop() defaultLabelId!: number;
    @Prop({ default: true }) rightMargin!: boolean;
    @Prop({ default: true }) assigneeRequired!: boolean;
    @Prop({ default: () => [] }) comboData!: LabelDto[];
    @Prop({ default: '100%' }) maxWidth!: number;

    loading = true;

    greekSearchFilter = greekSearchFilter;

    selectEntry() {
        this.$emit('update-filter', this.selectedLabel);
    }

    async mounted() {
        this.loading = false;
    }

    @Watch('comboData', { immediate: true })
    onComboDataChanged() {
        if (!this.comboData || !this.defaultLabelId) {
            return;
        }

        const foundItem = this.comboData.find(item => item.id === this.defaultLabelId);

        if (foundItem) {
            this.selectedLabel = foundItem;
            this.$emit('update-filter', this.selectedLabel);
        }
    }

    optimalTextColor(color: string) {
        return getOptimalTextColor(color);
    }

}
